import React, {useEffect, useState} from 'react';
import BootstrapTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import {putFireStatusAlarm} from "../../api/apiClient";

const FireAlarmRelease = ({
                            propData,
                            updateList
                          }) => {

  const [alarmInfo, setAlarmInfo] = useState({});

  useEffect(() => {
    // setAlarmInfo({
    //   fcltyDtlNo: propData.fclty_dtl_no,
    //   fcltyNo: propData.fclty_no,
    //   fireNo: propData.fire_no,
    // })
  }, []);

  const onClickRelease = (e, idx = 0) => {
    e.preventDefault();
    putFireStatusAlarm(propData[idx])
        .then(res => {
          updateList();
        });
  };

  return (
      <BootstrapTable hover className={"table text-center"}>
        <thead className={"table-head text-secondary"}>
        <tr className={"text-center"}>
          <th className={"col"}>경보해제 단위</th>
          <th className={"col"}>경보해제 횟수</th>
          <th className={"col"}>경보해제 실행</th>
        </tr>
        </thead>
        <tbody className={"table-body text-white text-center"}>
        {
          Array.isArray(propData) ?
              (propData.map((elem, idx) => {
                return <tr key={idx}>
                  <td>{elem.fclty_dtl_nm}</td>
                  <td>{elem.relis_co}</td>
                  <td>
                    <Button
                        type={"button"}
                        onClick={(e) => {
                          onClickRelease(e, idx)
                        }}
                    >경보해제</Button>
                  </td>
                </tr>;
              })) :
              ('')
        }
        </tbody>
      </BootstrapTable>
  );
};

export default FireAlarmRelease;
